import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Trash2, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <DollarSign className="w-6 h-6 text-naranja-500" data-id="element-223" />,
    title: 'Ingredientes caros',
    desc: <>
          Recetas que piden <strong data-id="element-224">semillas exóticas</strong> que no encuentras
          en el súper o cuestan una fortuna.
        </>
  }, {
    icon: <Trash2 className="w-6 h-6 text-naranja-500" data-id="element-225" />,
    title: 'Desperdicio de comida',
    desc: <>
          Compras verduras que terminan <strong data-id="element-226">pudriéndose</strong> en el cajón
          porque no supiste cómo usarlas rápido.
        </>
  }, {
    icon: <BatteryWarning className="w-6 h-6 text-naranja-500" data-id="element-227" />,
    title: 'Agotamiento total',
    desc: <>
          Pasar <strong data-id="element-228">3 horas</strong> el domingo haciendo 'Meal Prep' no es
          vida, es un <strong data-id="element-229">segundo trabajo no remunerado</strong>.
        </>
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-10 px-4 bg-cream-50" data-id="element-230">
      <div className="max-w-5xl mx-auto" data-id="element-231">
        <div className="text-center mb-16" data-id="element-232">
          <h2 className="text-3xl md:text-4xl font-black text-charcoal-900 mb-4" data-id="element-233">
            La trampa de las{' '}
            <span className="text-naranja-500 line-through decoration-4" data-id="element-234">
              "Loncheras de Instagram"
            </span>
          </h2>
          <p className="text-xl text-charcoal-800 max-w-2xl mx-auto" data-id="element-235">
            Has intentado mejorar. Quizás compraste moldes de figuritas o te
            uniste a grupos de "Mamás Fit". Pero la realidad te golpeó:
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-236">
          {problems.map((prob, idx) => <motion.div key={idx} variants={itemVariants} className="bg-white p-8 rounded-3xl shadow-soft border border-cream-200 hover:border-naranja-300 transition-colors" data-id="element-237">
              <div className="w-14 h-14 bg-naranja-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-238">
                {prob.icon}
              </div>
              <h3 className="text-xl font-bold text-charcoal-900 mb-3" data-id="element-239">
                {prob.title}
              </h3>
              <p className="text-charcoal-800 leading-relaxed" data-id="element-240">{prob.desc}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}